import { WSLoader, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { CertifiedSecureDigitalPaymentsTooltip } from "../../../components/CertifiedSecureDigitalPaymentsTooltip/CertifiedSecureDigitalPaymentsTooltip";
import {
  SetupLayout,
  SetupLayoutProps
} from "../../../components/SetupFlow/SetupFlowLayout";
import { openInNewTab } from "../../../utils/openInNewTab";

type Props = {} & SetupLayoutProps;

export const PaymentsSetupLayout: React.FC<Props> = ({ ...layoutProps }) => (
  <SetupLayout
    {...layoutProps}
    banner={
      <WSText
        onClick={() => {
          openInNewTab("https://www.wingspan.app/security");
        }}
      >
        Wingspan is PCI Certified Secure.
        <CertifiedSecureDigitalPaymentsTooltip ml="XS" />
      </WSText>
    }
  />
);

export const PaymentsSetupLayoutLoading: React.FC = () => (
  <PaymentsSetupLayout>
    <WSLoader.Spinner py="L" />
  </PaymentsSetupLayout>
);
